import { LinearProgress, Stack } from "@mui/material";
import { isEmpty, take } from "lodash";
import { useNavigate } from "react-router-dom";
import Actions from "../../components/actions/Actions";
import AddFab from "../../components/actions/AddFab";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../../misc/useLimit";
import { useOpenInNewTab } from "../../misc/useOpenInNewTab";
import { useRewards } from "../../rewards/useRewards";
import { useAdminFiltersValue } from "../useAdminFilters";
import RewardCard from "./RewardCard";

const RewardsList = () => {
  const navigate = useNavigate();
  const { openChildInNewTab } = useOpenInNewTab();
  const { limit, loadMore } = useLimit();
  const { rewards, isLoading } = useRewards();
  const { query } = useAdminFiltersValue("rewards");

  const filteredPackages = (rewards ?? []).filter((p) => isEmpty(query) || p.name.toLowerCase().includes(query));

  return (
    <Stack
      sx={{
        height: "100%",
      }}
    >
      {isLoading && <LinearProgress />}
      <InfiniteScroll
        dataLength={limit < filteredPackages.length ? limit : filteredPackages.length}
        hasMore={limit < filteredPackages.length}
        fetchData={loadMore}
      >
        {take(filteredPackages, limit).map((p) => (
          <RewardCard
            key={p.id}
            value={{ ...p, name: p.name }}
            onClick={() => navigate(p.id)}
            onContextMenu={() => openChildInNewTab(p.id)}
          />
        ))}
      </InfiniteScroll>
      <Actions>
        <AddFab label="dodaj nagrodę" onClick={() => navigate("new")} />
      </Actions>
    </Stack>
  );
};

export default RewardsList;
